





























import { Component, Vue } from 'vue-property-decorator';
import PromotionForm from '@promotions/shared/components/PromotionForm.vue';
import { AdminRoutes } from '@/app/shared/utilities/routes-names';
import { Promotion } from '@/app/shared/utilities/static-types';
import { createPromotionAction } from '@promotions/shared/actions';
@Component({
  components: {
    PromotionForm,
  },
})
export default class CreatePromotion extends Vue {
  public promotionMainRoute = AdminRoutes.PROMOTIONS_LIST;
  public showError = false;
  public errorMessage = '';

  public onCloseAlert() {
    this.showError = false;
    this.errorMessage = '';
  }

  public async createPromotion(promotion: Promotion): Promise<void> {
    try {
      this.showError = false;
      await createPromotionAction(promotion);
      this.$router.push(this.promotionMainRoute);
    } catch (e) {
      this.errorMessage = this.$t(e.message).toString();
      this.showError = true;
      throw e;
    }
  }
}
